import React, { useEffect, useState } from "react";
import Widgets from "../../../widgets";
import strings from "../../../utils/strings";
import { useTranslation } from "react-i18next";
import { getOneVersionDocx } from "../../../modules/TNC/tncThunk";
import { resetOneVersionDocx } from "../../../modules/TNC/tncSlice";
import { useDispatch, useSelector } from "react-redux";
import ToastPopup from "../../../widgets/Toast/toastPopup";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import "./viewTermsCondition.css";

const ViewTermsCondition = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const breadcrumbs = ["tncPP", "viewTncPP"];
  const nav = useNavigate();
  const paths = [strings.navigation.termsCondition, `${location.pathname}${location.search}`];
  const { t } = useTranslation();
  const [tncData, setTncData] = useState({});
  const { oneVersionSuccess, oneVersionErr } = useSelector((state) => state.tnc);

  const queryParams = queryString.parse(location.search);

  useEffect(() => {
    const userId = queryParams?.id;
    if (userId) {
      dispatch(getOneVersionDocx({ userId }));
    } else {
      nav(strings.navigation.termsCondition);
    }
  }, []);

  useEffect(() => {
    if (oneVersionErr) {
      console.log(oneVersionErr);
      ToastPopup.error(oneVersionErr);
      nav(strings.navigation.termsCondition);
    }
    if (oneVersionSuccess && oneVersionSuccess.status === "success") {
      setTncData(oneVersionSuccess.data);
      console.log(oneVersionSuccess.data);
    }
    dispatch(resetOneVersionDocx());
  }, [oneVersionSuccess, oneVersionErr]);

  return (
    <div className="department-box article-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="department-heading">
          {t("tncVersionNO")} : {tncData?.version}
        </div>
      </div>
      <div className="department-results">
        {t("createdOn")} {moment(tncData?.updatedAt).format("MMMM Do YYYY, h:mm:ss A")}
      </div>
      <div className="tnc-terms-body">
        <div className="department-heading">{t("tncEng")}</div>
        <div className="tnc-mt2" dangerouslySetInnerHTML={{ __html: tncData?.content?.en?.terms_and_conditions }}></div>
      </div>
      <div className="tnc-terms-body">
        <div className="department-heading">{t("tncVietnam")}</div>
        <div className="tnc-mt2" dangerouslySetInnerHTML={{ __html: tncData?.content?.vi?.terms_and_conditions }}></div>
      </div>
      <div className="tnc-terms-body">
        <div className="department-heading">{t("ppEng")}</div>
        <div className="tnc-mt2" dangerouslySetInnerHTML={{ __html: tncData?.content?.en?.privacy_policy }}></div>
      </div>
      <div className="tnc-terms-body">
        <div className="department-heading">{t("ppVietnam")}</div>
        <div className="tnc-mt2" dangerouslySetInnerHTML={{ __html: tncData?.content?.vi?.privacy_policy }}></div>
      </div>
    </div>
  );
};

export default ViewTermsCondition;
